export default __webpack_public_path__ + "static/media/img4.856eeb02.png";